/**
 * POST `auth/logout` — погасить refresh-сессию на сервере при выходе:
 * иначе украденный refresh работал бы до конца срока. Сеть упала — всё
 * равно выходим локально.
 */

import {apiEnabled, http, readTeamRefresh, writeTeamRefresh} from '@services/utils';

export const logoutTeam = async (): Promise<void> => {
  const refreshToken = readTeamRefresh();
  writeTeamRefresh(null);
  if (!apiEnabled || refreshToken === null) return;
  try {
    await http('auth/logout', {method: 'POST', body: {refreshToken}, skipCaseConversion: true});
  } catch {
    // сессия и так умрёт по сроку — выход не блокируем
  }
};
